module.exports = __webpack_public_path__ + "assets/address-active.31f96450.svg";